export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      tours: 'Tours',
      transfers: 'Transfers',
      reviews: 'Reviews',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    home: {
      heroSubtitle: "Puerto Plata's Premier Tour Company",
      heroTitle1: 'EXPERIENCE',
      heroTitle2: 'THE REAL',
      heroTitle3: 'DOMINICAN REPUBLIC',
      heroDescription: 'Puerto Plata has it all. Experience it with us.',
      planTrip: 'Plan Your Trip',
      viewTours: 'View Tours',
      airportTransfers: 'Airport Transfers',
      fromPrice: 'From $50/vehicle',
      featuredTours: 'Featured Tours',
      exploreParadise: 'Explore Paradise',
      fiveStarRated: '5-Star Rated',
      reviewsCount: '2,500+ Reviews',
      ourServices: 'OUR SERVICES',
      servicesTitle1: 'Everything You',
      servicesTitle2: 'Need for Your',
      servicesTitle3: 'Perfect Journey',
      servicesDescription: 'From airport pickups to customized excursions, we provide comprehensive transportation and tour services across the Dominican Republic.',
      airportTransfersTitle: 'Airport Transfers',
      airportTransfersDesc: 'Reliable transportation from any airport in the Dominican Republic. Private, shared, and VIP options available.',
      viewOptions: 'View Options',
      excursionsTitle: 'Private & Group Excursions',
      excursionsDesc: 'Discover hidden gems and popular attractions. Waterfalls, beaches, historical sites, and more.',
      privateGroupAvailable: 'Private & Group Available',
      fromPerson: 'From $65/person',
      exploreTours: 'Explore Tours',
      cityToursTitle: 'City Tours',
      cityToursDesc: "Explore Puerto Plata's rich history, culture, and landmarks with our expert local guides.",
      duration: '4-6 Hours Duration',
      includes: 'Includes: Guide, Transport, Entrance Fees',
      viewDetails: 'View Details',
      customServicesTitle: 'Custom Services',
      customServicesDesc: 'Create your perfect itinerary. We tailor every detail to match your preferences and schedule.',
      tailoredToYou: 'Tailored to You',
      contactUs: 'Contact Us',
      exploreDestinations: 'EXPLORE DOMINICAN DESTINATIONS',
      destinationsSubtitle: 'We cover all major airports and destinations across the island',
      attractions: 'Attractions',
      beachParadise: 'Beach Paradise',
      colonialCity: 'Colonial City',
      whaleWatching: 'Whale Watching & Beaches',
      golfLuxury: 'Golf & Luxury',
      explore: 'Explore',
      bookIn3Steps: 'Book in 3 Easy Steps',
      step1Title: 'Choose Your Service',
      step1Desc: 'Select from transfers, tours, or custom options',
      step2Title: 'Pick Date & Details',
      step2Desc: 'Enter your travel information',
      step3Title: 'Secure Payment',
      step3Desc: 'Pay safely and receive instant confirmation',
      reserveExperience: 'Reserve Your Experience',
      trustedByThousands: 'Trusted by Clients',
      whatGuestsSay: 'What Our Guests Say',
      readMoreTripAdvisor: 'Read More on TripAdvisor',
      leaveReview: 'Leave a Review',
      getInTouch: 'Get in Touch',
      getInTouchDesc: "Have questions? We're here to help plan your perfect trip",
      callUs: 'Call Us',
      available247: 'Available 24/7 for bookings and support',
      emailUs: 'Email Us',
      respondWithin24: "We'll respond within 24 hours",
      visitUs: 'Visit Us',
      followUs: 'Follow Us',
      unforgettableMoments: 'UNFORGETTABLE MOMENTS',
      happyTravelers: 'Our Happy Travelers',
      happyTravelersDesc: 'Real moments from real customers enjoying unforgettable experiences with Leury Tours',
      shareExperience: 'Share your Leury Tours experience with us!',
      followUsAt: 'Follow Us @LeuryTours',
      likeOurPage: 'Like Our Page',
      // Video Section
      discoverBeauty: 'DISCOVER THE BEAUTY',
      videoPuertoPlataTitle: 'Experience Puerto Plata',
      videoPuertoPlataDesc: 'Watch this stunning video and discover why Puerto Plata is one of the most beautiful destinations in the Caribbean. Crystal-clear beaches, majestic mountains, rich history, and warm people await you.',
      watchVideo: 'Watch Video'
    },
    booking: {
      serviceType: 'Service Type',
      monkeyTour: 'Monkey Tour',
      cityTour: 'City Tour',
      transportation: 'Transportation',
      waterfallsDamajagua: 'Waterfalls of Damajagua',
      customService: 'Custom Service',
      date: 'Date',
      time: 'Time',
      passengers: 'Number of Passengers',
      passenger: 'Passenger',
      passengersPlural: 'Passengers',
      pickupLocation: 'Pickup Location',
      pickupPlaceholder: 'e.g., PUJ Airport, Hotel Name',
      destination: 'Destination',
      destinationPlaceholder: 'e.g., Puerto Plata, Hotel Name',
      fullName: 'Full Name',
      namePlaceholder: 'Your full name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone',
      phonePlaceholder: '+1 (809) 555-1234',
      estimatedTotal: 'Estimated Total:',
      continuePayment: 'Continue to Payment',
      processing: 'Processing...',
      successMessage: 'Booking request submitted successfully! We\'ll contact you shortly.',
      errorMessage: 'Something went wrong. Please try again.',
      secure: 'Secure'
    },
    contact: {
      name: 'Name',
      namePlaceholder: 'Your full name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone',
      phonePlaceholder: '+1 (809) 555-1234',
      serviceInterest: 'Service Interest',
      selectService: 'Select a service',
      monkeyTour: 'Monkey Tour',
      cityTour: 'City Tour',
      transportation: 'Transportation',
      waterfallsDamajagua: 'Waterfalls of Damajagua',
      customService: 'Custom Service',
      generalInquiry: 'General Inquiry',
      message: 'Message',
      messagePlaceholder: 'Tell us about your travel plans...',
      characters: 'characters',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      successMessage: "Message sent successfully! We'll get back to you soon.",
      errorMessage: 'Something went wrong. Please try again.'
    },
    tours: {
      heroTitle: 'Unforgettable Excursions',
      heroDescription: 'Discover the best of the Dominican Republic with our expertly curated tours and adventures',
      ourExperiences: 'Our Experiences',
      chooseAdventure: 'Choose Your Adventure',
      chooseAdventureDesc: 'Each tour is carefully designed to give you an authentic, safe, and unforgettable Dominican Republic experience',
      readFullDescription: 'Read Full Description',
      readLess: 'Read Less',
      tourHighlights: 'Tour Highlights',
      whatsIncluded: "What's Included",
      startingFrom: 'Starting from',
      adults: 'adults',
      kids: 'kids (age till 12 years old)',
      youngGuys: 'young guys (13-17 years old)',
      bookThisTour: 'Book This Tour',
      whyTourWithUs: 'Why Tour With Us?',
      whyTourDesc: 'We go above and beyond to make every tour unforgettable',
      safetyFirst: 'Safety First',
      safetyDesc: 'Certified guides, safety equipment, and insured vehicles on every tour',
      expertGuides: 'Expert Local Guides',
      expertDesc: 'Bilingual guides with deep knowledge of Dominican culture and nature',
      smallGroups: 'Small Groups',
      smallGroupsDesc: 'Intimate group sizes for a personalized and comfortable experience',
      bestValue: 'Best Value',
      bestValueDesc: 'All-inclusive pricing with no hidden fees — everything is covered',
      cantFind: "Can't Find What You're Looking For?",
      cantFindDesc: 'We create custom tours tailored to your interests, schedule, and budget',
      requestCustomTour: 'Request Custom Tour',
      reviews: 'reviews',
      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Everything you need to know before your adventure',
      faq1Question: 'What should I wear and bring to the tours?',
      faq1Answer: 'For waterfall tours, wear comfortable clothes you can get wet in, water shoes or closed-toe shoes with good grip, and bring a change of clothes. For city tours, wear comfortable walking shoes and light clothing. We recommend bringing sunscreen, insect repellent, a hat, and a reusable water bottle.',
      faq2Question: 'Are the tours suitable for children and seniors?',
      faq2Answer: 'Yes! Our City Tour and Monkey Tour are suitable for all ages. The Waterfalls of Damajagua tour requires moderate physical fitness and is recommended for ages 8 and up. We always adapt the experience to accommodate different fitness levels.',
      faq3Question: 'What is your cancellation policy?',
      faq3Answer: 'We offer free cancellation up to 24 hours before the tour start time for a full refund. Cancellations made less than 24 hours in advance are subject to a 50% fee. No-shows are non-refundable.',
      faq4Question: 'Is transportation included in the tour price?',
      faq4Answer: 'Yes! All our tours include round-trip transportation from your hotel or the cruise port in Puerto Plata. We pick you up and drop you off at your location for your convenience.',
      faq5Question: 'What languages do your guides speak?',
      faq5Answer: 'All our guides are fully bilingual in English and Spanish. We can also arrange guides in other languages upon request with advance notice.',
      faq6Question: 'What happens if it rains on the day of my tour?',
      faq6Answer: 'Light rain usually doesn\'t affect our tours — in fact, the waterfalls are even more spectacular! In case of severe weather, we will contact you to reschedule at no additional cost.',
      faq7Question: 'How do I pay for my tour?',
      faq7Answer: 'We accept PayPal, credit cards, and cash payments. A deposit may be required to confirm your booking, with the remaining balance due on the day of the tour.',
      faq8Question: 'Can I book a private tour for my group?',
      faq8Answer: 'Absolutely! We offer private tours for families, couples, and groups of any size. Contact us for custom pricing and personalized itineraries tailored to your preferences.'
    },
    transfers: {
      heroSubtitle: 'Safe and reliable',
      heroTitle: 'Safe and Reliable Airport Transfers',
      heroDescription: 'Choose your origin and destination airport to calculate your transfer',
      bookNow: 'Book Now',
      allAirports: 'We Cover All Airports',
      airportsTitle: 'We Cover All Airports',
      airportsDescription: 'Choose your origin and destination airport to calculate your transfer',
      toPuertoPlata: 'to Puerto Plata',
      destinations: 'Destinations',
      destinationsDescription: 'Choose your origin and destination airport to calculate your transfer',
      ourFleet: 'Our Fleet',
      chooseVehicle: 'Personalized support ensuring safety, punctuality, and stress-free navigation to destinations.',
      from: 'From',
      capacity: 'Capacity',
      passengers: 'passengers',
      bookVehicle: 'Book Vehicle',
      calculateTransfer: 'Calculate Transfer',
      calculateDescription: 'Choose your origin and destination airport to calculate your transfer',
      fromLabel: 'From',
      toLabel: 'To',
      pickupPlaceholder: 'Enter your pickup location',
      destinationPlaceholder: 'Enter your destination',
      date: 'Date',
      time: 'Time',
      passengersLabel: 'Passengers',
      passenger: 'passenger',
      serviceType: 'Service Type',
      estimatedPrice: 'Estimated Price',
      bookTransfer: 'Book Transfer',
      processing: 'Processing...',
      successMessage: 'Your booking has been successfully submitted',
      errorMessage: 'There was an error processing your booking',
      secure: 'Secure',
      airport: 'Airport',
      selectAirport: 'Select an airport',
      tripType: 'Trip Type',
      oneWay: 'One Way',
      roundTrip: 'Round Trip',
      perPerson: 'per person',
      minimumPeople: 'Minimum 2 people',
      pricePerPerson: 'Price per person',
      totalPrice: 'Total Price',
      puertoPlataAirport: 'Puerto Plata (POP)',
      santiagoAirport: 'Santiago (STI)',
      puntaCanaAirport: 'Punta Cana (PUJ)',
      santoDomingoAirport: 'Santo Domingo (SDQ)',
      destination: 'Destination',
      securePayment: 'Secure Payment'
    },
    footer: {
      stayUpdated: 'Stay Updated',
      getBestPrices: 'Get exclusive deals and travel tips',
      emailPlaceholder: 'Your email address',
      explore: 'Explore',
      transfers: 'Airport Transfers',
      tours: 'Excursions',
      cityTours: 'City Tours',
      customServices: 'Custom Services',
      destinations: 'Destinations',
      followUs: 'Follow Us',
      allRightsReserved: '© 2026 Leury Tours. All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      termsConditions: 'Terms of Service'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Sobre Nosotros',
      tours: 'Tours',
      transfers: 'Traslados',
      reviews: 'Reseñas',
      contact: 'Contacto',
      bookNow: 'Reservar Ahora'
    },
    home: {
      heroSubtitle: 'La mejor empresa de tours de Puerto Plata',
      heroTitle1: 'EXPERIMENTA',
      heroTitle2: 'LA VERDADERA',
      heroTitle3: 'REPÚBLICA DOMINICANA',
      heroDescription: 'Puerto Plata lo tiene todo. Experiméntalo con nosotros.',
      planTrip: 'Planifica tu Viaje',
      viewTours: 'Ver Tours',
      airportTransfers: 'Traslados al Aeropuerto',
      fromPrice: 'Desde $50/vehículo',
      featuredTours: 'Tours Destacados',
      exploreParadise: 'Explora el Paraíso',
      fiveStarRated: '5 Estrellas',
      reviewsCount: '2,500+ Reseñas',
      ourServices: 'NUESTROS SERVICIOS',
      servicesTitle1: 'Todo lo que',
      servicesTitle2: 'Necesitas para tu',
      servicesTitle3: 'Viaje Perfecto',
      servicesDescription: 'Desde recogidas en el aeropuerto hasta excursiones personalizadas, ofrecemos servicios completos de transporte y tours en toda la República Dominicana.',
      airportTransfersTitle: 'Traslados al Aeropuerto',
      airportTransfersDesc: 'Transporte confiable desde cualquier aeropuerto de la República Dominicana. Opciones privadas, compartidas y VIP disponibles.',
      viewOptions: 'Ver Opciones',
      excursionsTitle: 'Excursiones Privadas y Grupales',
      excursionsDesc: 'Descubre joyas ocultas y atracciones populares. Cascadas, playas, sitios históricos y más.',
      privateGroupAvailable: 'Privado y Grupal Disponible',
      fromPerson: 'Desde $65/persona',
      exploreTours: 'Explorar Tours',
      cityToursTitle: 'Tours de Ciudad',
      cityToursDesc: 'Explora la rica historia, cultura y monumentos de Puerto Plata con nuestros guías locales expertos.',
      duration: 'Duración 4-6 Horas',
      includes: 'Incluye: Guía, Transporte, Entradas',
      viewDetails: 'Ver Detalles',
      customServicesTitle: 'Servicios Personalizados',
      customServicesDesc: 'Crea tu itinerario perfecto. Adaptamos cada detalle a tus preferencias y horario.',
      tailoredToYou: 'Hecho a tu Medida',
      contactUs: 'Contáctanos',
      exploreDestinations: 'EXPLORA DESTINOS DOMINICANOS',
      destinationsSubtitle: 'Cubrimos todos los aeropuertos y destinos principales de la isla',
      attractions: 'Atracciones',
      beachParadise: 'Paraíso de Playa',
      colonialCity: 'Ciudad Colonial',
      whaleWatching: 'Avistamiento de Ballenas y Playas',
      golfLuxury: 'Golf y Lujo',
      explore: 'Explorar',
      bookIn3Steps: 'Reserva en 3 Pasos Fáciles',
      // Puerto Plata Section
      discoverPuertoPlata: 'DESCUBRE PUERTO PLATA',
      puertoPlataSubtitle: 'La Costa del Ámbar de República Dominicana - Donde la historia, naturaleza y aventura se encuentran',
      puertoPlataDescription: 'Puerto Plata, conocida como la "Costa del Ámbar", es uno de los destinos más hermosos e históricos del Caribe. Con sus impresionantes playas, majestuosas montañas y rico patrimonio colonial, esta provincia ofrece experiencias inolvidables para cada viajero.',
      // Attractions
      telefericoTitle: 'Teleférico y Monte Isabel de Torres',
      telefericoDesc: 'Sube en el único teleférico del Caribe hasta la cima del Monte Isabel de Torres. Disfruta de vistas panorámicas impresionantes de la ciudad y la costa, visita los jardines botánicos y la icónica estatua del Cristo Redentor.',
      damajaguaTitle: '27 Charcos de Damajagua',
      damajaguaDesc: 'Una aventura emocionante a través de 27 cascadas escondidas en la selva tropical. Salta, deslízate y nada por piscinas naturales de agua cristalina rodeadas de exuberante vegetación.',
      amberMuseumTitle: 'Museo del Ámbar',
      amberMuseumDesc: 'Descubre la mejor colección de ámbar dominicano del mundo, incluyendo piezas raras con insectos prehistóricos. Ubicado en una hermosa mansión victoriana en el corazón de la ciudad.',
      fortSanFelipeTitle: 'Fortaleza San Felipe',
      fortSanFelipeDesc: 'La fortaleza colonial más antigua de las Américas, construida en 1577 para proteger contra piratas. Explora sus muros históricos y disfruta de impresionantes vistas del Océano Atlántico.',
      playaDoradaTitle: 'Playa Dorada',
      playaDoradaDesc: 'Una playa prístina de arena dorada con aguas turquesas tranquilas, perfecta para nadar, deportes acuáticos y relajación. Rodeada de resorts de clase mundial y un campo de golf de 18 hoyos.',
      oceanWorldTitle: 'Ocean World Adventure Park',
      oceanWorldDesc: 'Nada con delfines, leones marinos y tiburones en este parque marino de clase mundial. Cuenta con acuarios de arrecifes tropicales, una selva tropical y encuentros interactivos con animales.',
      sosúaBeachTitle: 'Playa Sosúa',
      sosúaBeachDesc: 'Una hermosa playa en forma de media luna famosa por su excelente snorkeling, vibrantes arrecifes de coral y encantadores restaurantes frente al mar con mariscos frescos.',
      cabareteSurfTitle: 'Cabarete - Paraíso del Surf y Kite',
      cabareteDesc: 'Destino mundialmente reconocido para kiteboarding y windsurf. Disfruta de las condiciones perfectas de viento, vibrante vida nocturna y ambiente relajado de playa.',
      step1Title: 'Elige tu Servicio',
      step1Desc: 'Selecciona entre traslados, tours u opciones personalizadas',
      step2Title: 'Elige Fecha y Detalles',
      step2Desc: 'Ingresa tu información de viaje',
      step3Title: 'Pago Seguro',
      step3Desc: 'Paga de forma segura y recibe confirmación instantánea',
      reserveExperience: 'Reserva tu Experiencia',
      trustedByThousands: 'Confiado por Clientes',
      whatGuestsSay: 'Lo que Dicen Nuestros Huéspedes',
      readMoreTripAdvisor: 'Leer Más en TripAdvisor',
      leaveReview: 'Dejar una Reseña',
      getInTouch: 'Ponte en Contacto',
      getInTouchDesc: '¿Tienes preguntas? Estamos aquí para ayudarte a planificar tu viaje perfecto',
      callUs: 'Llámanos',
      available247: 'Disponible 24/7 para reservas y soporte',
      emailUs: 'Escríbenos',
      respondWithin24: 'Responderemos en 24 horas',
      visitUs: 'Visítanos',
      followUs: 'Síguenos',
      unforgettableMoments: 'MOMENTOS INOLVIDABLES',
      happyTravelers: 'Nuestros Viajeros Felices',
      happyTravelersDesc: 'Momentos reales de clientes reales disfrutando experiencias inolvidables con Leury Tours',
      shareExperience: '¡Comparte tu experiencia con Leury Tours!',
      followUsAt: 'Síguenos @LeuryTours',
      likeOurPage: 'Dale Me Gusta',
      // Video Section
      discoverBeauty: 'DESCUBRE LA BELLEZA',
      videoPuertoPlataTitle: 'Experimenta Puerto Plata',
      videoPuertoPlataDesc: 'Mira este impresionante video y descubre por qué Puerto Plata es uno de los destinos más hermosos del Caribe. Playas cristalinas, montañas majestuosas, rica historia y gente cálida te esperan.',
      watchVideo: 'Ver Video'
    },
    booking: {
      serviceType: 'Tipo de Servicio',
      monkeyTour: 'Tour de Monos',
      cityTour: 'Tour de Ciudad',
      transportation: 'Transporte',
      waterfallsDamajagua: 'Cascadas de Damajagua',
      customService: 'Servicio Personalizado',
      date: 'Fecha',
      time: 'Hora',
      passengers: 'Número de Pasajeros',
      passenger: 'Pasajero',
      passengersPlural: 'Pasajeros',
      pickupLocation: 'Lugar de Recogida',
      pickupPlaceholder: 'ej., Aeropuerto PUJ, Nombre del Hotel',
      destination: 'Destino',
      destinationPlaceholder: 'ej., Puerto Plata, Nombre del Hotel',
      fullName: 'Nombre Completo',
      namePlaceholder: 'Tu nombre completo',
      email: 'Correo Electrónico',
      emailPlaceholder: 'tu@email.com',
      phone: 'Teléfono',
      phonePlaceholder: '+1 (809) 555-1234',
      estimatedTotal: 'Total Estimado:',
      continuePayment: 'Continuar al Pago',
      processing: 'Procesando...',
      successMessage: '¡Solicitud de reserva enviada con éxito! Te contactaremos pronto.',
      errorMessage: 'Algo salió mal. Por favor intenta de nuevo.',
      secure: 'Seguro'
    },
    contact: {
      name: 'Nombre',
      namePlaceholder: 'Tu nombre completo',
      email: 'Correo Electrónico',
      emailPlaceholder: 'tu@email.com',
      phone: 'Teléfono',
      phonePlaceholder: '+1 (809) 555-1234',
      serviceInterest: 'Servicio de Interés',
      selectService: 'Selecciona un servicio',
      monkeyTour: 'Tour de Monos',
      cityTour: 'Tour de Ciudad',
      transportation: 'Transporte',
      waterfallsDamajagua: 'Cascadas de Damajagua',
      customService: 'Servicio Personalizado',
      generalInquiry: 'Consulta General',
      message: 'Mensaje',
      messagePlaceholder: 'Cuéntanos sobre tus planes de viaje...',
      characters: 'caracteres',
      sendMessage: 'Enviar Mensaje',
      sending: 'Enviando...',
      successMessage: '¡Mensaje enviado con éxito! Te responderemos pronto.',
      errorMessage: 'Algo salió mal. Por favor intenta de nuevo.'
    },
    tours: {
      heroTitle: 'Excursiones Inolvidables',
      heroDescription: 'Descubre lo mejor de la República Dominicana con nuestros tours y aventuras cuidadosamente seleccionados',
      ourExperiences: 'Nuestras Experiencias',
      chooseAdventure: 'Elige tu Aventura',
      chooseAdventureDesc: 'Cada tour está cuidadosamente diseñado para brindarte una experiencia auténtica, segura e inolvidable en la República Dominicana',
      readFullDescription: 'Leer Descripción Completa',
      readLess: 'Leer Menos',
      tourHighlights: 'Destacados del Tour',
      whatsIncluded: 'Qué Incluye',
      startingFrom: 'Desde',
      adults: 'adultos',
      kids: 'niños (hasta 12 años)',
      youngGuys: 'jóvenes (13-17 años)',
      bookThisTour: 'Reservar Este Tour',
      whyTourWithUs: '¿Por Qué Viajar con Nosotros?',
      whyTourDesc: 'Hacemos todo lo posible para que cada tour sea inolvidable',
      safetyFirst: 'Seguridad Primero',
      safetyDesc: 'Guías certificados, equipo de seguridad y vehículos asegurados en cada tour',
      expertGuides: 'Guías Locales Expertos',
      expertDesc: 'Guías bilingües con profundo conocimiento de la cultura y naturaleza dominicana',
      smallGroups: 'Grupos Pequeños',
      smallGroupsDesc: 'Tamaños de grupo íntimos para una experiencia personalizada y cómoda',
      bestValue: 'Mejor Valor',
      bestValueDesc: 'Precios todo incluido sin cargos ocultos — todo está cubierto',
      cantFind: '¿No Encuentras lo que Buscas?',
      cantFindDesc: 'Creamos tours personalizados adaptados a tus intereses, horario y presupuesto',
      requestCustomTour: 'Solicitar Tour Personalizado',
      reviews: 'reseñas',
      faqTitle: 'Preguntas Frecuentes',
      faqSubtitle: 'Todo lo que necesitas saber antes de tu aventura',
      faq1Question: '¿Qué debo usar y llevar a los tours?',
      faq1Answer: 'Para tours de cascadas, usa ropa cómoda que pueda mojarse, zapatos de agua o zapatos cerrados con buen agarre, y trae ropa de cambio. Para tours de ciudad, usa zapatos cómodos para caminar y ropa ligera. Recomendamos traer protector solar, repelente de insectos, sombrero y una botella de agua reutilizable.',
      faq2Question: '¿Los tours son adecuados para niños y personas mayores?',
      faq2Answer: '¡Sí! Nuestro Tour de Ciudad y Tour de Monos son adecuados para todas las edades. El tour de las Cascadas de Damajagua requiere condición física moderada y se recomienda para mayores de 8 años. Siempre adaptamos la experiencia para acomodar diferentes niveles de condición física.',
      faq3Question: '¿Cuál es su política de cancelación?',
      faq3Answer: 'Ofrecemos cancelación gratuita hasta 24 horas antes del inicio del tour para un reembolso completo. Las cancelaciones realizadas con menos de 24 horas de anticipación están sujetas a un cargo del 50%. Las ausencias no son reembolsables.',
      faq4Question: '¿El transporte está incluido en el precio del tour?',
      faq4Answer: '¡Sí! Todos nuestros tours incluyen transporte de ida y vuelta desde tu hotel o el puerto de cruceros en Puerto Plata. Te recogemos y te dejamos en tu ubicación para tu comodidad.',
      faq5Question: '¿Qué idiomas hablan sus guías?',
      faq5Answer: 'Todos nuestros guías son completamente bilingües en inglés y español. También podemos organizar guías en otros idiomas bajo solicitud con aviso previo.',
      faq6Question: '¿Qué pasa si llueve el día de mi tour?',
      faq6Answer: 'La lluvia ligera generalmente no afecta nuestros tours — ¡de hecho, las cascadas son aún más espectaculares! En caso de clima severo, te contactaremos para reprogramar sin costo adicional.',
      faq7Question: '¿Cómo pago mi tour?',
      faq7Answer: 'Aceptamos PayPal, tarjetas de crédito y pagos en efectivo. Puede requerirse un depósito para confirmar tu reserva, con el saldo restante a pagar el día del tour.',
      faq8Question: '¿Puedo reservar un tour privado para mi grupo?',
      faq8Answer: '¡Por supuesto! Ofrecemos tours privados para familias, parejas y grupos de cualquier tamaño. Contáctanos para precios personalizados e itinerarios adaptados a tus preferencias.'
    },
    transfers: {
      heroSubtitle: 'Seguro y confiable',
      heroTitle: 'Traslados Aéreos Seguros y Confiables',
      heroDescription: 'Elige tu aeropuerto de origen y destino para calcular tu traslado',
      bookNow: 'Reservar Ahora',
      allAirports: 'Cubrimos Todos los Aeropuertos',
      airportsTitle: 'Cubrimos Todos los Aeropuertos',
      airportsDescription: 'Elige tu aeropuerto de origen y destino para calcular tu traslado',
      toPuertoPlata: 'a Puerto Plata',
      destinations: 'Destinos',
      destinationsDescription: 'Elige tu aeropuerto de origen y destino para calcular tu traslado',
      ourFleet: 'Nuestra Flota',
      chooseVehicle: 'Soporte personalizado garantizando seguridad, puntualidad y navegación sin estrés a los destinos.',
      from: 'Desde',
      capacity: 'Capacidad',
      passengers: 'pasajeros',
      bookVehicle: 'Reservar Vehículo',
      calculateTransfer: 'Calcular Traslado',
      calculateDescription: 'Elige tu aeropuerto de origen y destino para calcular tu traslado',
      fromLabel: 'Desde',
      toLabel: 'Hasta',
      pickupPlaceholder: 'Ingresa tu ubicación de recogida',
      destinationPlaceholder: 'Ingresa tu destino',
      date: 'Fecha',
      time: 'Hora',
      passengersLabel: 'Pasajeros',
      passenger: 'pasajero',
      serviceType: 'Tipo de Servicio',
      estimatedPrice: 'Precio Estimado',
      bookTransfer: 'Reservar Traslado',
      processing: 'Procesando...',
      successMessage: 'Tu reserva se ha enviado con éxito',
      errorMessage: 'Hubo un error al procesar tu reserva',
      secure: 'Seguro',
      airport: 'Aeropuerto',
      selectAirport: 'Selecciona un aeropuerto',
      tripType: 'Tipo de Viaje',
      oneWay: 'Solo Ida',
      roundTrip: 'Ida y Vuelta',
      perPerson: 'por persona',
      minimumPeople: 'Mínimo 2 personas',
      pricePerPerson: 'Precio por persona',
      totalPrice: 'Precio Total',
      puertoPlataAirport: 'Puerto Plata (POP)',
      santiagoAirport: 'Santiago (STI)',
      puntaCanaAirport: 'Punta Cana (PUJ)',
      santoDomingoAirport: 'Santo Domingo (SDQ)',
      destination: 'Destino',
      securePayment: 'Pago Seguro'
    },
    footer: {
      stayUpdated: 'Mantente Actualizado',
      getBestPrices: 'Recibe ofertas exclusivas y consejos de viaje',
      emailPlaceholder: 'Tu correo electrónico',
      explore: 'Explorar',
      transfers: 'Traslados al Aeropuerto',
      tours: 'Excursiones',
      cityTours: 'Tours de Ciudad',
      customServices: 'Servicios Personalizados',
      destinations: 'Destinos',
      followUs: 'Síguenos',
      allRightsReserved: '© 2026 Leury Tours. Todos los derechos reservados.',
      privacyPolicy: 'Política de Privacidad',
      termsConditions: 'Términos de Servicio'
    }
  }
};

export type TranslationKey = keyof typeof translations.en;
